import React from 'react';

const ActionButtons = ({ hasTabs, onAddExercise, onAddWorkout, onAddType }) => {
  return (
    <div className="flex gap-2">
      {hasTabs && (
        <>
          <button
            onClick={onAddExercise}
            className="hidden rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:block"
          > 
            Add Exercise
          </button>
          <button
            onClick={onAddWorkout}
            className="hidden rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:block"
          > 
            Add Workout
          </button>
        </>
      )}
      <button
        onClick={onAddType}
        className="hidden rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:block"
      > 
        Add Type
      </button>
    </div>
  );
};

export default ActionButtons;